import {
  PsychologicalPriceStrategy,
  useComputeChoosePriceMutation,
} from '@/lib/graphql/generated/graphql';
import { useUndoDealItems } from '@/lib/hooks/useUndoDealItems';
import { historyItemsFromMutationUpdates } from '@/lib/hooks/useUpdateDealItems';
import { trackEvent } from '@/lib/mixpanel';

export const useComputeChoosePrice = (dealId: string) => {
  const [computeChoosePriceMutation, { loading, error }] =
    useComputeChoosePriceMutation();
  const { pushUndoEntry } = useUndoDealItems(dealId);

  /** Compute choose price for specific items */
  const computeChoosePrice = async (
    itemIds: string[],
    strategy: PsychologicalPriceStrategy
  ) => {
    const result = await computeChoosePriceMutation({
      variables: { dealId, itemIds, strategy },
    });
    const response = result.data?.computeChoosePriceV2;
    if (response?.__typename === 'MutationUpdateDealItemsSuccess') {
      pushUndoEntry(historyItemsFromMutationUpdates(response.updates));
      trackEvent('PRICING_COMPUTE_SUCCEEDED', {
        dealId,
        strategy,
        itemCount: itemIds.length,
      });
    } else {
      trackEvent('PRICING_COMPUTE_FAILED', {
        dealId,
        strategy,
        itemCount: itemIds.length,
        errorCode:
          response?.__typename === 'DomainException'
            ? response.code
            : 'unknown_error',
      });
    }
    return result;
  };

  return {
    computeChoosePrice,
    loading,
    error,
  };
};
